import axiosClient, { app_uri } from "../../../utils/axiosFactory";
import { RegistrationClient } from "../../parentApi";

const client = new RegistrationClient(app_uri, axiosClient());

export default client;
